document.addEventListener("DOMContentLoaded", () => {
  const products = document.querySelectorAll(".product-grid-item");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const primaryImage = entry.target.querySelector(".product-grid-item__image--primary");
        const secondaryImage = entry.target.querySelector(".product-grid-item__image--secondary");

        if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
          primaryImage.style.opacity = "0";
          secondaryImage.style.opacity = "1";
        } else {
          primaryImage.style.opacity = "1";
          secondaryImage.style.opacity = "0";
        }
      });
    },
    {
      threshold: 0.3,
    }
  );

  products.forEach((product) => observer.observe(product));
});
